import {createContext, useContext} from 'react'
import {type GameStore, type GameStoreType} from './gameStore.ts'
import {useStore} from 'zustand'

// eslint-disable-next-line @typescript-eslint/naming-convention
export const GameStoreContext = createContext<GameStore | null>(null)

export const useGameStore = <T>(selector: (state: GameStoreType) => T) => {
    const gameStore = useContext(GameStoreContext)
    if(gameStore === null) throw new Error('GameStoreContext.Provider is missing in the component tree')

    return useStore(gameStore, selector)
}
